<template>
<div class="whitespace-no-wrap overflow-auto no-scrollbar">
      <transition-group
        v-if="filtersSelected "
        name="fade"
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOutDown"
      >
        <button
          v-for="filter in filtersSelected"
          :key="filter.name"
          class="btn btn-primary items-center justify-center mx-2 my-4"
          @click="removeFilter(filter)"
        >
          <div class="flex">
            {{ filter.name }}
            <img loading="lazy" class="pl-4 w-8" src="/img/icons/close-white.svg" alt="X" />
          </div>
        </button>
      </transition-group>
      <button
        v-if="filtersSelected.length"
        class="btn btn-seconday items-center justify-center mx-2 my-4"
        @click="clearFilters()"
      >
        <div class="flex">
          {{ trans.get('our-seeds.cancel') }}
        </div>
      </button>
     </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GET_FILTERS_SELECTED } from '../../store/shop/types';
import { REMOVE_FILTER_ACTION } from '../../store/shop/types';
import { CLEAR_FILTERS_ACTION } from '../../store/shop/types';

export default {
    computed: {
        ...mapGetters({
            filtersSelected: GET_FILTERS_SELECTED,
        }),
    },
    methods: {
        ...mapActions({
            removeFilter: REMOVE_FILTER_ACTION,
            clearFilters: CLEAR_FILTERS_ACTION
        })
    }
}
</script>

